import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const DocumentationOSContext = createContext();

export function DocumentationOSProvider({ children }) {
  const [documentsRequest, setDocumentsRequest] = useState([]);
  const [requestPercent, setRequestPercent] = useState([]);
  const [idTimeout, setIdTimeout] = useState(null);
  const [getNewItens, setGetNewItens] = useState(false);

  useEffect(() => {
    if(documentsRequest?.length === 0) return;
    if(idTimeout) {
      clearTimeout(idTimeout);
    }
    const newRequests = documentsRequest.filter(document => document.downloadItem === true);
    setRequestPercent(newRequests);
  }, [documentsRequest])

  useEffect(() => {
    if(requestPercent?.length === 0) return;
    const idTimeoutNew = setTimeout(() => {
      const newItens = requestPercent.map(req => {
        if(Math.round(req.percentDownload) >= 100) setGetNewItens(true);
        return ({
          ...req,
          downloadItem: req.percentDownload < 100,
          percentDownload: req.percentDownload < 96 ? req.percentDownload + 4.8 : 100,
        })
      });
      setDocumentsRequest([...newItens]);
    }, 1000);
    setIdTimeout(idTimeoutNew);
  }, [requestPercent, setGetNewItens]);

  const addNewDocument = useCallback((document) => {
    const idx = documentsRequest.findIndex(dc => dc.osNumber === document.osNumber);
    if(idx === -1) {
      const oldDocuments = documentsRequest;
      oldDocuments.push({
        ...document,
        downloadItem: true,
        percentDownload: 0,
      });
      setDocumentsRequest([...oldDocuments]);
    }
  }, [documentsRequest, setDocumentsRequest]);


  return (
    <DocumentationOSContext.Provider
      value={{
        documentsRequest,
        addNewDocument,
        getNewItens,
        setGetNewItens,
      }}
    >
      {children}
    </DocumentationOSContext.Provider>
  )
}

export function useDocumentationOS() {
  return useContext(DocumentationOSContext);
}
